import { Orders_Vouchers_App_Voucher } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';
import { QueryOptions } from '@treyd-io/core/types/hasura';
import { getGqlQueryParams } from '@treyd-io/core/utils/hasura';

export type Voucher = Pick<
  Orders_Vouchers_App_Voucher,
  | 'id'
  | 'order_id'
  | 'status'
  | 'value'
  | 'currency'
  | 'created'
  | 'modified'
  | 'slug'
>;

export type GetCompanyVouchersType = {
  orders_vouchers_app_voucher: Array<Voucher>;
  orders_vouchers_app_voucher_aggregate: {
    aggregate: {
      count: number;
    };
  };
};

export const getCompanyVouchersQuery = (queryOptions?: QueryOptions) => {
  const { queryParams, whereClause } = getGqlQueryParams(queryOptions);

  return gql`
  query getCompanyVouchers {
    orders_vouchers_app_voucher ${queryParams} {
      id
      order_id
      value
      currency
      status
      created
      modified
      slug
    }
    orders_vouchers_app_voucher_aggregate  ${
      whereClause ? `(where: ${whereClause})` : ''
    } {
      aggregate {
        count
      }
    }
  }
` as TypedDocumentNode<GetCompanyVouchersType, undefined>;
};
